import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractService {

  constructor(
    private http: HttpClient
  ) {
  }

  sendWizard(formData: FormData): Observable<void> {
    return this.http.post<void>(environment.baseUrl + `/contract-furnizare/wizard`, formData);
  }

  sendSupplierWizard(wizard: any): Observable<void> {
    return this.http.post<void>(environment.baseUrl + `/contract-furnizare/wizard-furnizor`, wizard);
  }

  sendIndexCompletion(formData: FormData): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/contract-furnizare/completare-index`, formData);
  }

  extendContractValidity(contract: any): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/contract-furnizare/extend-contract-validity`, contract);
  }
}
